// src/components/questionnaire/QuestionnaireChooser.tsx
import React, { memo } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { QUESTIONNAIRES } from "../../utils/constants";

export const QuestionnaireChooser = memo(function QuestionnaireChooser({
  questionnaireSlugs = null,
  permittedQuestionnaires = [],
  titleKey = null,
  titleFallback = "",
  hideIfEmpty = false,
  layout = "list",
  gridClassName = "",
  spanFirstWhenOdd = false,
  className = "",
  titleClassName = "subtitle-text text-center",
}) {
  const { t } = useTranslation("common");
  const requestedSlugs = Array.isArray(questionnaireSlugs)
    ? questionnaireSlugs
    : permittedQuestionnaires;
  const questionnaireBySlug = new Map(
    QUESTIONNAIRES.map((questionnaire) => [questionnaire.slug, questionnaire]),
  );
  const questionnaires = requestedSlugs
    .map((slug) => questionnaireBySlug.get(slug))
    .filter(Boolean);

  if (hideIfEmpty && questionnaires.length === 0) {
    return null;
  }

  const renderedQuestionnaires =
    layout === "grid" ? (
      <div
        role="list"
        className={["grid grid-cols-2 auto-rows-fr gap-3", gridClassName]
          .filter(Boolean)
          .join(" ")}
      >
        {questionnaires.map(({ slug, labelKey }, index) => {
          const shouldSpanColumns =
            spanFirstWhenOdd && questionnaires.length % 2 === 1 && index === 0;

          return (
            <div
              key={slug}
              role="listitem"
              className={["h-full", shouldSpanColumns ? "col-span-2" : ""]
                .filter(Boolean)
                .join(" ")}
            >
              <Link
                to={`/questionnaires/${slug}`}
                className="small-outlined-button !flex-row !justify-center !w-full !min-h-16 !px-4 !py-3 whitespace-normal leading-tight"
              >
                {t(labelKey)}
              </Link>
            </div>
          );
        })}
      </div>
    ) : (
      <div className="w-full flex flex-col gap-3">
        {questionnaires.map(({ slug, labelKey }) => (
          <Link
            key={slug}
            to={`/questionnaires/${slug}`}
            className="primary-button w-full text-center"
          >
            {t(labelKey)}
          </Link>
        ))}
      </div>
    );

  return (
    <div
      className={["w-full flex flex-col gap-3", className]
        .filter(Boolean)
        .join(" ")}
    >
      {titleKey || titleFallback ? (
        <h3 className={titleClassName}>
          {t(titleKey || titleFallback, titleFallback || titleKey)}
        </h3>
      ) : null}

      {renderedQuestionnaires}
    </div>
  );
});
